var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.record)?_c('div',[(_vm.rsettings[0].settings.csize)?_c('span',[_vm._v("Students in Class: "),_c('strong',[_vm._v(_vm._s(_vm.record.total_students_in_class))])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }